import React, {useState} from 'react'
import Select from "react-select";
import InformationModal from '../../../components/shared/informationmodal/InformationModal'
import {
    saveConfigurationByDeviceList,
    saveConfigurationByGroupList,
    saveTimerPeriodsByDeviceList, saveTimerPeriodsByGroupList
} from '../../../helpers/reduxstore/reducers/groupReducer'
import {useDispatch} from 'react-redux'
import ModalTopText from '../../../components/shared/modaltoptext/ModalTopText'
import MenuTabs from '../menutabs/MenuTabs'
import SaveForGroupsModal from '../saveforgroupsmodal/SaveForGroupsModal'
import SubPagesSettings from "../subpages/SubPagesSettings.js";
import {useTranslation} from "react-i18next";
import {loadCurrentDeviceWrapper} from "../../../helpers/deviceHelper.js";
import {loadCurrentDevice} from "../../../helpers/reduxstore/reducers/deviceReducer.js";
import {useNavigate, useParams} from "react-router-dom";
import {configurationSubPages, settingsModalTypes} from "../../../helpers/constants.js";
import {isAwareDevice} from "../../../helpers/helperfunctions.js";
import {getDeviceTypesFromGroups} from "../../../api/api"

/** Renders the wrapper for the individual setting pages
 * @param {object} device device data
 */
export default function SettingsContent({device, onlyShowReboot}) {
    const {t} = useTranslation(['settingspage', 'common', 'locales'])
    const dispatch = useDispatch()
    const {deviceSerialNumber, subPage} = useParams()
    const [stagedChanges, setStagedChanges] = useState({})
    const [type, setType] = useState(settingsModalTypes.settings)
    const [showGroupModal, setShowGroupModal] = useState(false)
    const [showGroupWarningModal, setShowGroupWarningModal] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [selectedDeviceIds, setSelectedDeviceIds] = useState([device.id])
    const [selectedGroupIds, setSelectedGroupIds] = useState([])
    const [selectedDeviceTypes, setSelectedDeviceTypes] = useState([])
    const [deviceTypeList, setDeviceTypeList] = useState([])
    const showOnlyOperationPage = onlyShowReboot === false ? false : true
    
    const navigate = useNavigate()
    const isAware = isAwareDevice(device.serial_number)

    function getCurrentPage() {
        const validPages = [configurationSubPages.operation, configurationSubPages.setpoints,
            configurationSubPages.timers, configurationSubPages.startpriority, configurationSubPages.filter]
        if (!validPages.includes(subPage)) return configurationSubPages.operation
        return subPage
    }

    const promptForSave = (changes, saveForGroup, type = settingsModalTypes.settings) => {
        setStagedChanges(changes)
        setType(type)
        if (saveForGroup) {
            setSelectedDeviceIds([])
            setSelectedGroupIds([])
            setShowGroupModal(true)
        } else setShowConfirmation(true)
    }
    const cancelConfiguration = () => {
        setSelectedDeviceIds([device.id])
        setStagedChanges({})
        setShowGroupModal(false)
        setShowConfirmation(false)
    }

    const onChangeDeviceType = (option) => {
        setSelectedDeviceTypes(option);
    };

    const saveForGroupValidation = async () => {
        if (selectedGroupIds.length === 0) {
            console.log("No groups selected, skipping validation")
            commitChanges()
            return;
        }
        try {
            console.log("Validating selected groups for device type consistency", selectedGroupIds, "isAware:", isAware);
            console.log("Calling getDeviceTypesFromGroups with group IDs", selectedGroupIds, "and isAware:", !isAware);
            const result = await getDeviceTypesFromGroups(selectedGroupIds, !isAware);
            console.log("getDeviceTypesFromGroups result", result);
            if(result !== null && result.deviceTypes.length > 1) {
                const options = [
                    ...result.deviceTypes
                        .slice() // create a copy
                        .sort() // sort alphabetically
                        .map(type => ({ value: type, label: type }))
                ];
               setDeviceTypeList(options);
               console.log("Multiple device types found in selected groups, prompting user to select device types before saving", options);
               setShowGroupWarningModal(true);
            }else {
                console.log("One or zero device types found in selected groups, proceeding with save", result);
                commitChanges();
            }
        } catch (error) {
            console.error("Validation failed in saveForGroupValidation", error);
        }
    }    

    const cancelShowGroupWarningModal = () => {
        setShowGroupWarningModal(false)
    }

    const acceptShowGroupWarningModal = () => {
        setShowGroupWarningModal(false)
        commitChanges()
    }

    const commitChanges = async () => {
        setShowGroupModal(false)
        setShowConfirmation(false)
        if (stagedChanges && (selectedDeviceIds.length !== 0 || selectedGroupIds.length !== 0)) {
            if (type === settingsModalTypes.settings) {
                const deviceTypes = selectedDeviceTypes.length > 0 ? selectedDeviceTypes.map(dt => dt.value) : [];
                if (selectedDeviceIds.length !== 0) {
                    await dispatch(saveConfigurationByDeviceList(stagedChanges, selectedDeviceIds, deviceTypes, !isAware));
                } else {
                    console.log("Saving configuration by group list with device types", deviceTypes);
                    await dispatch(saveConfigurationByGroupList(stagedChanges, selectedGroupIds, deviceTypes, !isAware));
                }
                loadCurrentDeviceWrapper(device, device.serial_number, dispatch);
            } else if (type === settingsModalTypes.periods) {
                if (selectedDeviceIds.length !== 0) {
                    await dispatch(saveTimerPeriodsByDeviceList(stagedChanges, selectedDeviceIds, !isAware));
                } else {
                    console.log("Saving timer periods by group list with device types", selectedDeviceTypes);
                    await dispatch(saveTimerPeriodsByGroupList(stagedChanges, selectedGroupIds, !isAware));
                }
                await dispatch(loadCurrentDevice(device.serial_number));
            }
        }
    }

    return (
        <>
            {/*=== Modals ===*/}
            <SaveForGroupsModal show={showGroupModal} dismiss={cancelConfiguration}
                                setSelectedGroupIds={setSelectedGroupIds}
                                accept={saveForGroupValidation}/>
            <InformationModal show={showConfirmation} title={t('settingspage:confirm_modal.title')}
                              body={t('settingspage:confirm_modal.body')}
                              dismiss={cancelConfiguration} accept={commitChanges}/>
        
            <InformationModal show={showGroupWarningModal} title={t('settingspage:save_group_multiple_device_types_modal.title')}
                              body={
                                <React.Fragment>
                                    <ModalTopText body={t('settingspage:save_group_multiple_device_types_modal.body')}/>
                                    <Select
                                    name="deviceTypes"
                                    placeholder={t('settingspage:save_group_multiple_device_types_modal.select')}
                                    value={selectedDeviceTypes}
                                    options={deviceTypeList}
                                    onChange={onChangeDeviceType}
                                    isMulti
                                    />
                                </React.Fragment>
                              }
                              dismiss={cancelShowGroupWarningModal} accept={acceptShowGroupWarningModal}
            />


            {/*=== Desktop ===*/}
            <div className='d-flex flex-grow-1 bg-white rounded-3 p-3 mb-3 d-xs-none'>
                <MenuTabs selectedSubSettingsPage={getCurrentPage()}
                          setSelectedSubSettingsPage={page => navigate(`/device/${deviceSerialNumber}/configurations/${page}`)} showOnlyOperationPage={showOnlyOperationPage}/>
                <SubPagesSettings className="px-sm-4 pb-sm-4 w-100" device={device} showOnlyReboot={onlyShowReboot}
                                  selectedSubSettingsPage={getCurrentPage()}
                                  promptForSave={promptForSave}/>
            </div>

            {/*=== Mobile ===*/}
            <div className='d-sm-none'>
                <select onChange={e => navigate(`/device/${deviceSerialNumber}/configurations/${e.target.value}`)}
                        value={getCurrentPage()} className="form-select shadow-none btn-md form-control">
                    <option value={configurationSubPages.operation}>{t('settingspage:menu.operation')}</option>
                    <option value={configurationSubPages.setpoints}>{t('settingspage:menu.setpoints')}</option>
                    <option value={configurationSubPages.timers}>{t('settingspage:menu.timers')}</option>
                    <option value={configurationSubPages.startpriority}>{t('settingspage:menu.priorities')}</option>
                    <option value={configurationSubPages.filter}>{t('locales:filter_settings_header')}</option>
                </select>
                <div className='p-0 mt-1'>
                    <SubPagesSettings device={device} selectedSubSettingsPage={getCurrentPage()}
                                      promptForSave={promptForSave}/>
                </div>
            </div>
        </>
    )
}